import {
  counselorStudentExamStatusList,
  counselorExamList,
  counselorExamStudentList,
} from '@/api/counselor'

export default {
  async counselorStudentExamStatusList({ }, data) {
    return counselorStudentExamStatusList(data)
  },
  async counselorExamList({ }, data) {
    return counselorExamList(data)
  },
  async counselorExamStudentList({ }, data) {
    return counselorExamStudentList(data)
  },
}
